import {Color} from '~/constants/style';

export const chartContainerStyle = {
  width: '100%',
  maxWidth: 120,
  height: 'auto',
  aspectRatio: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: '#fff',
  borderRadius: '50%',
};

export const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: Color.Purple600,
  mb: 2,
};

export const legendContainerStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  mb: 0.5,
};

export const legendDotStyle = {
  width: 18,
  height: 18,
  borderRadius: '4px',
  alignSelf: 'flex-start',
  marginTop: '1px',
};

export const iconWrapperStyle = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  transform: 'translateY(-2px)',
};

export const fieldStyle = {
  fontSize: '14px',
  fontWeight: 600,
  color: Color.TextPrimary,
  mt: '-3px',
};

export const percentageStyle = {
  fontSize: '12px',
  fontWeight: 400,
  color: Color.TextSecondary,
};

export const iconBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  whiteSpace: 'nowrap',
  mb: 2,
};

export const chartRowStyle = {
  width: '100%',
};

export const paperStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const iconTextRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  marginBottom: 1,
};
